<div class="commands-section">

    <!-- Manual Control Section -->
    <div class="control-section">
        <h4 class="text-md font-semibold flex items-center gap-2 mb-3">
            <mat-icon>settings_remote</mat-icon>
            Barrier Control
        </h4>
        <div class="control-buttons-grid">
            <!-- Pulse Button (Quick Open) -->
            <button class="control-btn pulse-btn" (click)="sendPulseCommand()"
                [disabled]="!barrierId || isSendingPulse()"
                matTooltip="Opens gate momentarily then closes automatically" matTooltipPosition="above">
                <div class="btn-icon">
                    @if (isSendingPulse()) {
                    <mat-spinner diameter="24" class="btn-spinner"></mat-spinner>
                    } @else {
                    <mat-icon class="icon-large">flash_on</mat-icon>
                    }
                </div>
                <div class="btn-content">
                    <span class="btn-title">Quick Open</span>
                    <span class="btn-subtitle">Pulse gate</span>
                </div>
            </button>

            <!-- Open Button (Keep Open) -->
            <button class="control-btn open-btn" (click)="sendOpenCommand()" [disabled]="!barrierId || isSendingOpen()"
                matTooltip="Keeps gate open until manually closed" matTooltipPosition="above">
                <div class="btn-icon">
                    @if (isSendingOpen()) {
                    <mat-spinner diameter="24" class="btn-spinner"></mat-spinner>
                    } @else {
                    <mat-icon class="icon-large">lock_open</mat-icon>
                    }
                </div>
                <div class="btn-content">
                    <span class="btn-title">Keep Open</span>
                    <span class="btn-subtitle">Hold until closed</span>
                </div>
            </button>

            <!-- Close Button -->
            <button class="control-btn close-btn" (click)="sendCloseCommand()"
                [disabled]="!barrierId || isSendingClose()" matTooltip="Closes the gate and clears open commands"
                matTooltipPosition="above">
                <div class="btn-icon">
                    @if (isSendingClose()) {
                    <mat-spinner diameter="24" class="btn-spinner"></mat-spinner>
                    } @else {
                    <mat-icon class="icon-large">lock</mat-icon>
                    }
                </div>
                <div class="btn-content">
                    <span class="btn-title">Close Gate</span>
                    <span class="btn-subtitle">Stop & close</span>
                </div>
            </button>
        </div>
    </div>

    <mat-divider class="my-4"></mat-divider>

    <!-- Recent Commands Toggle Header -->
    <div class="section-header commands-toggle-header" (click)="toggleCommandsSection()" role="button"
        [attr.aria-expanded]="commandsExpanded()">
        <h4 class="text-lg font-semibold flex items-center gap-2">
            <mat-icon>history</mat-icon>
            Recent Commands
        </h4>
        <div class="toggle-header-actions">
            @if (commandsExpanded()) {
            <button mat-icon-button color="primary" (click)="$event.stopPropagation(); loadCommands()"
                [disabled]="isLoading() || !barrierId" matTooltip="Refresh"> <mat-icon>refresh</mat-icon>
            </button>
            }
            <mat-icon class="expand-icon" [class.expanded]="commandsExpanded()">expand_more</mat-icon>
        </div>
    </div>

    @if (commandsExpanded()) {
    @if (isLoading()) {
    <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
    }

    @if (commands().length === 0 && !isLoading()) {
    <mat-icon class="empty-icon">inbox</mat-icon>
    <p class="empty-text">No commands found</p>
    }

    @if (commands().length > 0) {
    <table mat-table [dataSource]="commands()" class="commands-table">
        <!-- Command Type Column -->
        <ng-container matColumnDef="commandType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let command">
                <span class="command-type">{{ command.commandType || '-' }}</span>
            </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let command">
                <mat-chip [color]="getStatusColor(command.status)" class="status-chip">
                    {{ command.status || 'Unknown' }}
                </mat-chip>
            </td>
        </ng-container>

        <!-- License Plate Column -->
        <ng-container matColumnDef="licensePlate">
            <th mat-header-cell *matHeaderCellDef>License Plate</th>
            <td mat-cell *matCellDef="let command">
                <span class="license-plate">{{ command.licensePlate || '-' }}</span>
            </td>
        </ng-container>

        <!-- Triggered By Column -->
        <ng-container matColumnDef="triggeredBy">
            <th mat-header-cell *matHeaderCellDef>Triggered By</th>
            <td mat-cell *matCellDef="let command">
                <span class="triggered-by" [class.detection-label]="!!command.createdByDetection">{{
                    getCreatedBy(command) }}</span>
            </td>
        </ng-container>

        <!-- Command Sent At Column -->
        <ng-container matColumnDef="commandSentAt">
            <th mat-header-cell *matHeaderCellDef>Sent At</th>
            <td mat-cell *matCellDef="let command">
                <span class="timestamp">{{ command.commandSentAt ? (command.commandSentAt | date: 'short') : '-'
                    }}</span>
            </td>
        </ng-container>

        <!-- Duration Column -->
        <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef>Duration</th>
            <td mat-cell *matCellDef="let command">
                @if (command.durationMs !== null && command.durationMs !== undefined) {
                <span class="duration">
                    {{ command.durationMs }}ms
                </span>
                }
                @if (command.durationMs === null || command.durationMs === undefined) {
                <span>-</span>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.error-row]="row.errorMessage"
            [matTooltip]="row.errorMessage || ''" [matTooltipDisabled]="!row.errorMessage"></tr>
    </table>

    <!-- Paginator -->
    <mat-paginator [length]="totalCommands()" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
        [pageSizeOptions]="[5, 10, 25, 50]" (page)="onPageChange($event)" class="mt-4">
    </mat-paginator>
    }
    }
</div>